import Dialog from "@/v2-ui/dialog"
import Icon from "@/v2-ui/icon"
import Button from "@/v2-backoffice-client/components/button"
import { getUserEntraUrl } from "@/v2-backoffice-client/user/UserEntraButton"

type Conflict = {
  Email: string
  ExistingAzureId: string
}

export type UserCreateManyPhaseConfirmProps = {
  conflicts: Conflict[]
  loading: boolean
  onConfirm(): void
  onCancel(): void
}

function UserCreateManyPhaseConfirm(props: UserCreateManyPhaseConfirmProps) {
  const { conflicts, loading, onConfirm, onCancel } = props

  return (
    <>
      <Dialog.Header>
        <Dialog.Title>Existing Identities Found</Dialog.Title>
        <Dialog.Description>
          The following email addresses already have Azure identities. These
          users will be linked to their existing identities instead of creating
          new ones.
        </Dialog.Description>
      </Dialog.Header>

      <div className="py-4 space-y-3 max-h-60 overflow-y-auto">
        {conflicts.map((conflict) => (
          <div
            key={conflict.Email}
            className="flex items-center justify-between text-sm border-b pb-2 last:border-0"
          >
            <div className="space-y-0.5">
              <div className="font-medium">{conflict.Email}</div>
              <div className="text-xs text-muted-foreground">
                Azure ID: {conflict.ExistingAzureId}
              </div>
            </div>
            <a
              href={getUserEntraUrl(conflict.ExistingAzureId)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-xs text-primary hover:underline shrink-0"
            >
              <Icon src="entra" size={12} />
              Entra
            </a>
          </div>
        ))}
      </div>

      <Dialog.Footer className="flex justify-end gap-3 mt-4">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="button" isLoading={loading} onClick={onConfirm}>
          {loading ? "Creating..." : "Continue"}
        </Button>
      </Dialog.Footer>
    </>
  )
}

export default UserCreateManyPhaseConfirm
